import * as S from "./styles.ts";
import { PopupItem } from "./styles.ts";
import { useSlate } from "slate-react";
import {
  blockOptions,
  formattingOptions,
  isBlockActive,
  isMarkActive,
  toggleBlock,
  toggleMark,
} from "@admin/config/overrides/fieldTypes/MarkdownEditor/helpers";
import { Input, Popup } from "@template/components";
import ChevronDown from "@template/icons/ChevronDown.tsx";
import { Fragment } from "react";
import { Editor, Transforms } from "slate";

const ToolbarButton = ({
                         option,
                         disabled,
                       }: {
  option: {
    label: string;
    key: string;
    icon: any;
  };
  disabled?: boolean;
}) => {
  const slate = useSlate();
  const isMark = formattingOptions.some(({ key }) => key === option.key);
  const isBlock = blockOptions.some(({ key }) => key === option.key);

  const isActive = isMark
    ? isMarkActive(slate, option.key)
    : isBlockActive(slate, option.key);

  const onToggle = (e: any) => {
    e.preventDefault();
    if (isMark) {
      toggleMark(slate, option.key);
    } else if (isBlock) {
      toggleBlock(slate, option.key);
    }
  };

  return (
    <S.ButtonWrapper $isActive={isActive}>
      <S.Button
        key={option.key}
        onClick={onToggle}
        $disabled={disabled}
      >
        {option.icon}
      </S.Button>
    </S.ButtonWrapper>
  );
};

const LinkEditor = () => {
  const slate = useSlate();

  const existingLink = getActiveLink(slate);

  // @ts-ignore
  const url = existingLink?.url || "";
  // @ts-ignore
  const title = existingLink?.title || "";

  return (
    <>
      <Input
        type="text"
        label="URL"
        placeholder="/phone-numbers"
        fullWidth
        autoFocus
        value={url}
        onChange={(val) => {
          Transforms.setNodes(
            slate,
            {
              ...existingLink,
              url: val,
              //     @ts-ignore
            },
            { match: (n: any) => n.link === true },
          );
        }}
      />
      <Input
        type="text"
        label="Title"
        placeholder="Click to go to phone numbers"
        fullWidth
        value={title}
        onChange={(val) => {
          Transforms.setNodes(
            slate,
            {
              ...existingLink,
              title: val,
              //     @ts-ignore
            },
            { match: (n: any) => n.link === true },
          );
        }}
      />
    </>
  );
};

const getActiveLink = (editor) => {
  const [match] = Editor.nodes(editor, {
    // @ts-ignore
    match: (n) => n.link === true,
  });
  return match ? match[0] : null;
};

const Toolbar = ({ disabled }) => {
  const activeBlock = blockOptions.find((b) =>
    isBlockActive(useSlate(), b.key)
  );
  const linkIsActive = isMarkActive(useSlate(), "link");
  return (
    <S.ToolbarContainer>
      <S.ButtonsContainer>
        {[...formattingOptions.filter(({ key }) => key !== "link")].map(
          (option) => (
            <ToolbarButton
              option={option}
              key={option.key}
              disabled={disabled}
            />
          )
        )}
        <Popup
          isOpen={linkIsActive}
          triggerProps={{
            // @ts-ignore
            style: {
              flex: 1,
              borderRight: "1px solid #e0e0e0",
            },
          }}
          width={300}
          popupContent={<LinkEditor />}
        >
          <ToolbarButton
            option={formattingOptions.find(({ key }) => key === "link")}
          />
        </Popup>
        <Popup
          triggerProps={{
            // @ts-ignore
            style: {
              flex: 1,
            },
          }}
          popupContent={
            <S.PopupContainer>
              {blockOptions.map((option) => (
                <PopupItem key={option.key}>
                  <ToolbarButton option={option} />
                  {option.label}
                </PopupItem>
              ))}
            </S.PopupContainer>
          }
        >
          <ToolbarButton
            option={{
              label: "yo",
              key: "extra",
              icon: (
                <>
                  {activeBlock?.icon}
                  <ChevronDown style={{ marginLeft: 12 }} />
                </>
              ),
            }}
          />
        </Popup>
      </S.ButtonsContainer>
    </S.ToolbarContainer>
  );
};

export default Toolbar;
